<template>
  <div>
    <a
      href="https://app.zeplin.io/project/5f092773fa16ac9ddd3d2a2f/screen/5f0d0f46402f527e308cf261"
      >Selection</a
    >

    <h3>Simple selection</h3>
    <div class="w-248px my-n2 category-autocomplete">
      <v-autocomplete
        :items="['item1', 'item2']"
        placeholder="請選擇所屬BU"
        outlined
        dense
      >
      </v-autocomplete>
    </div>

    <h3>Date selection</h3>

    <h3>Dropdown selection</h3>
    <h5>Single Select</h5>
    <TableControlShowState></TableControlShowState>
    <h5>Multi Select</h5>
    <div class="support-downloads-autocomplete w-248px">
      <v-autocomplete
        :items="['item1', 'item2', 'item3']"
        :menu-props="{
          'offset-y': true,
          'nudge-bottom': 100,
        }"
        multiple
        outlined
        dense
      >
        <template v-slot:selection="{ item, index }">
          ({{ index }}) {{ item }}
          <!-- <span v-if="index === 0">{{ item }}</span> -->
          <!-- <span v-if="index === 1"> …+{{ item.length - 1 }}</span> -->
        </template>
      </v-autocomplete>
    </div>

    <h5>Multi select with Checkbox</h5>
    <div class="w-248px">
      <MultiSelectWithCheckbox
        v-model="selectedCheckboxes"
      ></MultiSelectWithCheckbox>
    </div>

    <h5>Multi Select with 2 Layers</h5>
    <!-- 自製 -->

    <h3>Multi Select + Closable Chips</h3>
    <div class="flex-grow-1 flex-basis-0 subcategory-combobox">
      <v-combobox
        class="w-180px"
        v-model="selectedItems"
        :items="['item1', 'item2']"
        multiple
        outlined
        dense
        chips
      >
        <template v-slot:selection="data">
          <v-chip
            :key="JSON.stringify(data.item)"
            v-bind="data.attrs"
            :input-value="data.selected"
            :disabled="data.disabled"
            @click:close="data.parent.selectItem(data.item)"
            close
          >
            <!-- <v-avatar
                  class="accent white--text"
                  left
                  v-text="data.item.slice(0, 1).toUpperCase()"
                ></v-avatar> -->
            {{ data.item }}
          </v-chip>
        </template>
      </v-combobox>
    </div>
  </div>
</template>

<script>
// doc: https://vuetifyjs.com/en/components/selects/#api 全選
// doc: https://vuetifyjs.com/en/components/autocompletes/#autocompletes chip
// doc: https://vuetifyjs.com/en/components/combobox/#combobox 新增
import TableControlShowState from '@/components/TableControlShowState.vue';
import MultiSelectWithCheckbox from '@/components/Selection/MultiSelectWithCheckbox.vue';

export default {
  components: {
    TableControlShowState,
    MultiSelectWithCheckbox,
  },
  data: () => ({
    selectedItems: [],
    selectedCheckboxes: [],
  }),
};
</script>

<style lang="scss">
.category-autocomplete {
  .v-autocomplete {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }
}

.subcategory-combobox {
  .v-combobox {
    .v-input__slot {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .v-text-field__details {
      display: none;
    }
  }

  // border
  fieldset {
    border-color: #d7dee7;
    border-radius: 8px;
  }
  .v-input--is-focused {
    border-color: $brand-500;
  }

  // placeholder color
  input::placeholder {
    color: #848fa0 !important;
  }

  .v-chip {
    background-color: #f7fafc !important;
    border: solid 1px #d7dee7;
  }

  .v-text-field__details {
    display: none;
  }
}
</style>
